import GoBackButton from '@/common/components/GoBackButton';
import LogRequestShow from '@/common/components/LogRequestShow';
import { ChevronsRightIcon } from 'lucide-react';
import { useParams } from 'react-router-dom';

const LogShow = () => {
  const { requestId } = useParams();

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-x-4 items-center">
          <GoBackButton fallback={`/logs`} />

          <p className="text-white-400 font-normal">
            Requisição
          </p>

          <ChevronsRightIcon color="#ffffffb3" />

          <h2>
            {requestId}
          </h2>
        </div>
      </div>

      <div className="h-[calc(100vh-64px-32px-40px)]">
        <LogRequestShow />
      </div>
    </div>
  );
};

export default LogShow;
